import { TiledGameObject } from "./phaserHelpers/HandyTypes";
import { PhaserButton } from "./Button";
import { Color } from "./ColorValue";
import TranslateApi from "src/utils/TranslateHelper";

export class TextBoxConfig {
    padding?: number = 20;
    fontSize: number;
    hollandCode: "r" | "i" | "a" | "s" | "e" | "c";
    translationKey: string;
    onBack?: any;
    onNext: any;
}

export class GameIntroTextBox extends Phaser.GameObjects.Container {
    config: TextBoxConfig;

    obWidth: number;

    background: Phaser.GameObjects.Image;
    border: Phaser.GameObjects.Image;
    paragraphs: Phaser.GameObjects.Text[];
    backButton: PhaserButton;
    nextButton: PhaserButton;

    constructor(scene: Phaser.Scene, ob: TiledGameObject, config: TextBoxConfig) {
        super(scene, ob.x, ob.y, []);

        this.obWidth = ob.width;
        this.config = config;

        this.createBox();
        scene.add.existing(this);
    }

    createBox() {
        var borderWidth = 10;
        var borderColor = Color.PLANET_COLORS.get(this.config.hollandCode.toUpperCase());
        var verticalSpacing = this.config.padding;
        var paragraphSpacing = 5;
        this.paragraphs = [];
        var textStyle = { fontFamily: 'Roboto Mono, Arial', color: "#F8E71C", fontSize: this.config.fontSize, padding: 10 };

        // Add all the paragraphs to one big textbox
        var translatedText = TranslateApi.translate(this.config.translationKey);
        // Split the translated text by newlines to create paragraphs
        translatedText.split("|").map(x => x.trim()).forEach((para: string) => {
            var paragraph = this.scene.add.text(this.config.padding, verticalSpacing, para, textStyle);
            paragraph.setWordWrapWidth(this.obWidth - 2 * this.config.padding, true);
            this.paragraphs.push(paragraph);
            verticalSpacing += paragraph.height + paragraphSpacing;
            this.setSize(Math.max(this.obWidth, paragraph.width), verticalSpacing);
        });

        // Back button
        if (this.config.onBack != null) {
            this.backButton = PhaserButton.createQuickBackButton(this.scene, this.config.padding + textStyle.padding, 0);
            this.backButton.setName("back");
            this.backButton.setVisible(false);
            this.backButton.on('buttonClicked', () => {
                this.config.onBack();
            });
        }

        // Next Button
        this.nextButton = PhaserButton.createQuickNextButton(this.scene, 0, 0);
        this.nextButton.getBackground().setTint(Color.KUDER_PRIMARY_BUTTON);
        this.setSize(this.width, this.height + this.nextButton.displayHeight + 2 * this.config.padding);
        
        this.nextButton.on('buttonClicked', () => {
            this.config.onNext();
        });
        
        this.nextButton.setY(this.displayHeight - this.nextButton.displayHeight - this.config.padding);
        if(this.backButton != null) {
            this.backButton.setY(this.displayHeight - this.backButton.displayHeight - this.config.padding);
        }
        
        // Add text box background
        this.background = this.scene.add.image(0, 0, "pixel");
        this.background.setOrigin(0);
        this.background.setDisplaySize(this.displayWidth, this.displayHeight);
        this.background.setTint(0x000000);
        this.background.setPosition(borderWidth + this.config.padding + textStyle.padding, borderWidth + this.config.padding + textStyle.padding);

        // Add text box border
        this.border = this.scene.add.image(0, 0, "pixel");
        this.border.setOrigin(0);
        this.border.setDisplaySize(this.background.displayWidth + 2 * borderWidth, this.background.displayHeight + 2 * borderWidth);
        this.border.setTint(borderColor);
        this.background.setPosition(borderWidth, borderWidth);

        this.nextButton.setX(this.border.getBounds().right - this.nextButton.displayWidth - this.config.padding - textStyle.padding);

        this.add(this.border);
        this.add(this.background);
        this.add(this.paragraphs);
        if(this.backButton != null) {
            this.add(this.backButton);
        }
        this.add(this.nextButton);

        this.setDepth(2);
    }

    // The button is a little off for some reason, so not using this.
    updateBox(newKey: string, backButtonVisibility: boolean) {
        this.paragraphs.forEach((p) => p.destroy());
        this.paragraphs = [];

        var borderWidth = 10;
        var verticalSpacing = this.config.padding;
        var paragraphSpacing = 5;
        var textStyle = { fontFamily: 'Roboto Mono, Arial', color: "#F8E71C", fontSize: this.config.fontSize, padding: 10 };

        // Add all the paragraphs to one big textbox
        var translatedText = TranslateApi.translate(newKey);
        // Split the translated text by newlines to create paragraphs
        translatedText.split("|").map(x => x.trim()).forEach((para: string) => {
            var paragraph = this.scene.add.text(this.config.padding, verticalSpacing, para, textStyle);
            paragraph.setWordWrapWidth(this.obWidth - 2 * this.config.padding, true);
            this.paragraphs.push(paragraph);
            verticalSpacing += paragraph.height + paragraphSpacing;
            this.setSize(Math.max(this.obWidth, paragraph.width), verticalSpacing);
        });

        this.add(this.paragraphs);

        this.setSize(this.width, this.height + this.backButton.displayHeight + 2 * this.config.padding);

        this.backButton.setY(this.displayHeight - this.backButton.displayHeight - this.config.padding);
        this.backButton.visible = backButtonVisibility;
        this.nextButton.setY(this.displayHeight - this.nextButton.displayHeight - this.config.padding);

        this.background.setDisplaySize(this.displayWidth, this.displayHeight);
        this.background.setPosition(borderWidth + this.config.padding + textStyle.padding, borderWidth + this.config.padding + textStyle.padding);

        this.border.setDisplaySize(this.background.displayWidth + 2 * borderWidth, this.background.displayHeight + 2 * borderWidth);
        this.background.setPosition(borderWidth, borderWidth);

        this.nextButton.setX(this.border.getBounds().right - this.nextButton.displayWidth - this.config.padding - textStyle.padding);

        var audio = this.scene.sound.add(newKey);
        audio.play();
    }
}



// WEBPACK FOOTER //
// ./src/games/shared/GameIntroTextBox.ts